import React from "react";
import styles from "./RefDoc.module.css";

const RefDoc = ({ related = [] }) => {
  return (
    <section className={styles.referenceCard}>
      <div className={styles.section}>
        <span className={styles.titleRow}>
          <h5>Reference Documents</h5>
        </span>

        <div className={styles.referenceList}>
          {related.length > 0 ? (
            related.map((item) => (
              <a
                key={`${item.standardId}-${item.issue}`}
                href={`/document/${item.standardId}`}
                className={styles.referenceItem}
              >
                <p className={styles.referenceTitle}>{item.title}</p>
                <p className={styles.referenceCategory}>
                  {item.referenceNumber} · Issue {item.issue}
                </p>
              </a>
            ))
          ) : (
            <p className={styles.noData}>No reference documents found.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default RefDoc;
